import { useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Col, Divider, Row } from "antd";

import { PlusOutlined, SearchOutlined } from "@ant-design/icons";

import OrganizationList from "./organizations/OrganizationList";

import { openNotification } from "@seims/shared";

import util from "../../utils/functions/custom";
import { Messages, Notify } from "../../services/custom/Messages";
import api from "../../services/citizenscienceService";
import { recordError } from "../../utils/logService";
import { OrganizationForm } from "./organizations";

export default function Organisations({
  formRef,
  onHideButtons,
  onSelectedOrganization,
  selectedOrganization,
  selectedRowKeys,
  setSelectedRowKeys,
  setSelectedGlobalOrganization,
  onUpdateSelected,
  onRemoveSelected,
}) {
  const [showCreate, setShowCreate] = useState(false);
  const [showPartnerList, setShowPartnerList] = useState(true);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [preselectedOrgs, setPreSelectedOrgs] = useState({});
  const scrollRef = useRef(null);

  let msg = "";

  useEffect(() => {
    // THis was added because the Organization page displayed halfway through
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, []);

  const handleRowKeySelection = (rows) => {
    setSelectedRowKeys(rows);
  };

  const handleSaveOrganization = (organization) => {
    // addOrganization(partner, address)
    setPreSelectedOrgs(organization);
    setHasUpdated(true);
  };

  const handleAddOrganization = (value) => {
    setShowCreate(value);
    onHideButtons(value);
    // setShowSearchButton(false);
  };

  const onShowPartnerList = (value) => {
    setShowPartnerList(value);
    onHideButtons(!value);
    setShowCreate(!value);
    // setShowAddButton(false)
  };

  return (
    <>
      <Card
        className="project-card"
        title={
          <span
            style={{ color: "black", fontWeight: "bold", fontSize: "20px" }}
          >
            <b>STEP 3: Partner(s)</b>
          </span>
        }
        bordered={false}
        headStyle={{ border: 0, textAlign: "left" }}
      >
        <p style={{ textAlign: "left" }}>
          Add a partner by either searching for an existing partner or creating
          a new partner
        </p>
        <div style={{ textAlign: "left" }}>
          <Alert
            description={
              <span>
                <b>Please Note:</b> Before proceeding to the next step, you must
                specifiy which partner(s) will provide Funding and Host
                Contributions
              </span>
            }
            type="info"
            showIcon
          />
        </div>
        <div ref={scrollRef}>
          <Row>
            <Button
              style={{ float: "left" }}
              type="primary"
              key="exists"
              // disabled={!showCreate}
              className="add-button-wiz"
              // onClick={(value) => handleAddOrganization((value = true))}
              onClick={(value) => onShowPartnerList((value = true))}
              
            >
              Search for an existing Partner(s)
            </Button>
            {/* <Button className="right-align-button edit-button" type="primary" shape="round" onClick={() => editProjectLead()} >
                Edit
              </Button> */}
            <span
              style={{
                marginTop: "26px",
                marginLeft: "20px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Or
            </span>

            <Button
              style={{ float: "left", marginLeft: "20px" }}
              type="primary"
              key="new"
              disabled={showCreate}
              className="add-button-wiz"
              onClick={(value) => handleAddOrganization((value = true))}
              icon={<PlusOutlined />}
            >
              Add a New Partner
            </Button>
          </Row>
          <Divider />
          {showCreate ? (
            <OrganizationForm
              formRef={formRef}
              onShowCreate={handleAddOrganization}
              onSaveOrganization={handleSaveOrganization}
            />
          ) : (
            <OrganizationList
              formRef={formRef}
              hasUpdated={hasUpdated}
              preselectedOrgs={preselectedOrgs}
              onHideButtons={(value) => handleAddOrganization((value = true))}
              onSelectedOrganization={onSelectedOrganization}
              onUpdateSelected={onUpdateSelected}
              onRemoveSelected={onRemoveSelected}
              selectedGlobalOrganization={selectedOrganization}
              selectedRowKeys={selectedRowKeys}
              setSelectedRowKeys={handleRowKeySelection}
              setSelectedGlobalOrganization={setSelectedGlobalOrganization}
            />
          )}
        </div>
      </Card>
    </>
  );
}
